import { PlanGoodsBaseModel } from './kymw0900-plan-goods-base.model';

export class CheckPlanGoodsRequestModel {

  // 企画商品基本マスタ
  public planGoodsBaseVO: PlanGoodsBaseModel = new PlanGoodsBaseModel();

  // 企画商品会員生協マスタVOリスト
  public planGoodsCoopList: Array<any> = new Array<any>();

  // 企画商品媒体別次回案内情報
  public planGoodsNextGuide: Array<any> = new Array<any>();

  // 企画商品詳細マスタリスト
  public planGoodsDetailList: Array<any> = new Array<any>();

  // 企画商品表組情報リスト
  public planGoodsListingList: Array<any> = new Array<any>();

  // 企画商品付随マークリスト
  public markPlanGoodsList: Array<any> = new Array<any>();

  // 商品企画付随文字情報（Ｐコード）リスト
  public planTextInfoGoodsList: Array<any> = new Array<any>();

  // 商品企画媒体別付随文字情報リスト
  public planGoodsMediumTextList: Array<any> = new Array<any>();

  // 商品企画付随文字情報（アイテムコード）リスト
  public planTextInfoItemList: Array<any> = new Array<any>();

  // 使用マークリスト
  public useMarkList: Array<any> = new Array<any>();

  // 企画商品アレルゲンマスタリスト
  public planGoodsAllergenList: Array<any> = new Array<any>();

  // 企画商品環境配慮商品（有無）リスト
  public planGoodsEcology1List: Array<any> = new Array<any>();

  // 企画商品環境配慮商品（区分）リスト
  public planGoodsEcology2List: Array<any> = new Array<any>();

  // 企画商品温暖化防止関連リスト
  public itemCodePromoteList: Array<any> = new Array<any>();

  // 企画商品容器包装材リスト
  public planGoodsContainList: Array<any> = new Array<any>();

  // 企画商品栄養成分分析単位リスト
  public planGoodsNutritionUnitList: Array<any> = new Array<any>();

  // 企画商品栄養成分詳細リスト
  public planGoodsNutritionDetailList: Array<any> = new Array<any>();

  // 抽選商品プロモーション情報
  public planGoodsLotteryPromotion = null;

  // ポイント交換商品プロモーション情報
  public planGoodsPointExchangePromotion = null;

  // 会員生協別ポイント情報
  public planGoodsCoopPointRate: Array<any> = new Array<any>();

  // 1物N価媒体プロモーション情報
  public planGoodsNvalPromotion = null;

  // 企画商品クーポンプロモーション情報
  public planGoodsCouponPromotion = null;

  // 会員生協別値引情報
  public couponApplicablePrice: Array<any> = new Array<any>();

  // 企画商品EC情報
  public planGoodsEC = null;

  // 会員生協別在庫限定情報
  public planGoodsEcStock: Array<any> = new Array<any>();

  // 予約商品情報
  public preOrderInfo = null;

  // 予約商品利用生協情報
  public preOrderCoop = null;

  // 予約詳細情報リスト
  public preOrderDetailInfoList: Array<any> = new Array<any>();

  // CWS商品企画アイコン指示情報
  public cwsPlanGoodsIcon: Array<any> = new Array<any>();
}
